import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Checkbox from '@tds/core-checkbox';

import { ServiceNameContainer, Td } from './css';
import RatePlanTableSubRow from './rateplanTableSubRow';

import { iotGeotabFleetTrackerOEM } from '../../../../utils/constant';

const RatePlanTableRow = ({
  orderType,
  productSelected,
  accountType,
  rowData,
  viewType,
  ratePlans,
  setRatePlans,
  isSubmitting
}) => {
  const {
    fields: { rateplanName, show50PercentUsCheckBox, deviceList, rateplanType }
  } = rowData;
  const rowSpanCount = deviceList.length;
  const is50PercntUSCheckBoxVisible =
    show50PercentUsCheckBox && viewType === 'advancedView';

  const [fiftyPercentInUS, setFiftyPercentInUS] = useState(() =>
    Object.keys(_.get(ratePlans, rateplanName, {})).some(deviceName =>
      _.get(ratePlans, `${rateplanName}.${deviceName}.fiftyPercentInUS`, false)
    )
  );
  const rowRef = useRef(false);

  useEffect(() => {
    if (viewType && rowRef.current) setFiftyPercentInUS(false);
    rowRef.current = true;
  }, [viewType]);

  return (
    <>
      {deviceList.map((deviceData, index) => (
        <tr key={_.get(deviceData, 'sys.id')}>
          {index === 0 && (
            <Td
              rowSpan={rowSpanCount}
              style={{
                paddingTop: rateplanName === iotGeotabFleetTrackerOEM ? 40 : '',
                verticalAlign:
                  rateplanName === iotGeotabFleetTrackerOEM ? 'top' : 'center',
                background: '#f7f7f7',
                fontWeight: '700'
              }}
            >
              <ServiceNameContainer>
                <p>{rateplanName}</p>
                {is50PercntUSCheckBoxVisible && (
                  <Checkbox
                    checked={fiftyPercentInUS}
                    name={`${rateplanName}-fiftyPercentInUS`}
                    value={`${rateplanName}-fiftyPercentInUS`}
                    label="More than 50% in the US?"
                    onChange={() => setFiftyPercentInUS(!fiftyPercentInUS)}
                  />
                )}
              </ServiceNameContainer>
            </Td>
          )}
          <RatePlanTableSubRow
            orderType={orderType}
            productSelected={productSelected}
            accountType={accountType}
            rateplanName={rateplanName}
            deviceData={deviceData}
            index={index}
            fiftyPercentInUS={fiftyPercentInUS}
            viewType={viewType}
            ratePlans={ratePlans}
            setRatePlans={setRatePlans}
            rateplanType={rateplanType}
            isSubmitting={isSubmitting}
          />
        </tr>
      ))}
    </>
  );
};

RatePlanTableRow.propTypes = {
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      rateplanName: PropTypes.string,
      show50PercentUsCheckBox: PropTypes.bool,
      rateplanType: PropTypes.string,
      deviceList: PropTypes.arrayOf(
        PropTypes.shape({
          deviceName: PropTypes.string,
          terms: PropTypes.arrayOf(
            PropTypes.shape({
              termName: PropTypes.string,
              termPrice: PropTypes.number,
              termPrice50PrecentUs: PropTypes.number
            })
          )
        })
      )
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired
};

export default RatePlanTableRow;
